module.exports = __webpack_public_path__ + "0496c91cdfaa6c3e76bf9262291b5895.jpg";